import hljs from "highlight.js";
import React, { useState } from "react";
import { getLanguageDisplayName } from "../utils/getLanguageDisplayName";
import { CopyButton } from "../../../../common/Components/Buttons/CopyButton";
import styles from "./styles.module.css";

interface Props {
  className?: string;
  children?: React.ReactNode;
  [key: string]: any;
}

export const CodeBlock = ({ className, children, ...props }: Props) => {
  const [isCodeBlockOpen, setIsCodeBlockOpen] = useState<boolean>(true);
  const codeString = String(children).replace(/\n$/, "");

  if (!className) {
    return <code {...props}>{children}</code>;
  }

  const match = /language-(\w+)/.exec(className);
  let highlighted: string;
  let languageName: string;

  try {
    if (match) {
      const lang = match[1];
      highlighted = hljs.highlight(codeString, { language: lang }).value;
      languageName = getLanguageDisplayName(lang);
    } else {
      const autoResult = hljs.highlightAuto(codeString);
      highlighted = autoResult.value;
      languageName = autoResult.language
        ? getLanguageDisplayName(autoResult.language)
        : "Code";
    }
  } catch (error) {
    highlighted = codeString;
    languageName = "Code";
  }

  return (
    <div className={styles["code-container"]}>
      <div
        onClick={() => setIsCodeBlockOpen(!isCodeBlockOpen)}
        className={styles["code-header"]}
      >
        <div className={styles["code-label"]}>{languageName}</div>
        <CopyButton
          copyContent={codeString}
          className={styles["copy-code-button"]}
        />
      </div>
      {isCodeBlockOpen && (
        <pre className={styles["code-wrapper"]} {...props}>
          <code
            className={className}
            dangerouslySetInnerHTML={{ __html: highlighted }}
          />
        </pre>
      )}
    </div>
  );
};
